/* eslint-disable no-console */
/* eslint-disable no-alert */
import { getProductDefaultQty } from "@DSG/Handlers/PopulateProductsWithQuantity";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchChangeQtyOrdered,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/ChangeQtyOrdered";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToChainBefore(chain, DispatchChangeQtyOrdered, props => {
    props.dispatch(
        loadRealTimeInventory({
            productIds: [props.parameter.productId],
            additionalQueryStringParameters: getProductDefaultQty(
                props.parameter.productId,
                props.parameter.qtyOrdered,
            ),
            onComplete: realTimeInventoryProps => {
                const realTimeInventory = realTimeInventoryProps?.apiResult;

                if (realTimeInventoryProps?.error) {
                    if (props.parameter.productId) {
                        props.dispatch({
                            type: "Pages/ProductList/FailedLoadRealTimeInventory",
                            productId: props.parameter.productId,
                        });
                    }
                } else if (realTimeInventory) {
                    props.dispatch({
                        type: "Pages/ProductList/CompleteLoadRealTimeInventory",
                        realTimeInventory,
                    });
                }
            },
        }),
    );
});
